import React, { useEffect, useState } from "react";
import AppRoutes from "../routes/AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import AlertWrapper from "../components/AlertWrapper";
import { Domain_URL } from "../constants/states";
import Loader from "../components/Loader";
import { getPatientNotification } from "../actions/dashboardAction";
import { checkIfAuthorized, logout } from "../actions/authAction";
import { useLocation } from "react-router-dom";
import { getUserDetail } from "../utils/helper";
import { DATE_FORMAT_APPLIED } from "../constants/types/settingsType";
function App() {
  const messages = useSelector((state) => state.alert.messages);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const alerts = messages.map((x) => (
    <AlertWrapper
      key={x.id}
      message={x.message}
      variant={x.variant}
      id={x.id}
    />
  ));

  useEffect(async () => {
    async function fetchData() {
      let response = await fetch(
        Domain_URL + "api/manageForms?action=getThemeSettings"
      );
      let json = await response.json();
      document.documentElement.style.setProperty(
        "--orange",
        json.fields[0].value
      );
      localStorage.setItem("theme", json.fields[0].value);
      let dateResponse = await fetch(
        Domain_URL + "api/manageForms?action=getDateSettings"
      );
      let dateJson = await dateResponse.json();
      localStorage.setItem("dateFormat", dateJson.fields[0].value);
      localStorage.setItem("round", dateJson.fields[2].value);
      localStorage.setItem("isLicenseRequired", dateJson.fields[3].value);
      localStorage.setItem("isTwoFactorRequired", dateJson.fields[4].value);
      dispatch({
        type: DATE_FORMAT_APPLIED,
        payload: dateJson?.fields[0]?.value,
      });
    }

    if (!localStorage.getItem("theme")) {
      fetchData();
    } else {
      document.documentElement.style.setProperty(
        "--orange",
        localStorage.getItem("theme")
      );
      dispatch({
        type: DATE_FORMAT_APPLIED,
        payload: localStorage.getItem("dateFormat"),
      });
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (location.pathname !== "/login" && getUserDetail()) {
      let expirationDate = new Date(getUserDetail()?.tokenExpiryDate); // Assuming the input is in UTC
      let currentDate = new Date();
      if (expirationDate < currentDate) {
        dispatch(logout());
      }
    }
  }, []);

  return (
    <>
      {isLoading && <Loader />}
      <AppRoutes />
      <div className="alert-box">{alerts}</div>
    </>
  );
}

export default App;
